module.exports = __webpack_public_path__ + "img/vegetable-salsify-350x184.550d9b75.jpg";